import { getIndicatorDefinition, type IndicatorKey } from "../lib/indicators";

interface IndicatorChipsProps {
  activeIndicators: IndicatorKey[];
  onRemove: (indicator: IndicatorKey) => void;
}

export function IndicatorChips({ activeIndicators, onRemove }: IndicatorChipsProps) {
  return (
    <div className="indicator-chips" aria-label="Active indicators">
      {activeIndicators.map((key) => {
        const indicator = getIndicatorDefinition(key);
        if (!indicator) {
          return null;
        }
        return (
          <button
            key={key}
            type="button"
            className="indicator-chip"
            style={{ ["--indicator-color" as string]: indicator.color }}
            onClick={() => onRemove(key)}
          >
            {`${indicator.label} ✕`}
          </button>
        );
      })}
    </div>
  );
}
